import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setEmailRateLimiter, fetchEmailRateLimiter, updateRateLimiter } from './ConfigureRateLimiterActions'
import ConfigureRateLimiter from './ConfigureRateLimiter'
import Spinner from '../../../../common/Spinners/Spinner/Spinner'

class ConfigureRateLimiterContainer extends React.Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    setEmailRateLimiter: PropTypes.func.isRequired,
    fetchEmailRateLimiter: PropTypes.func.isRequired,
    emailRateLimiter: PropTypes.number.isRequired,
    updateRateLimiter: PropTypes.func.isRequired,
    administratorId: PropTypes.number
  }

  componentDidMount () {
    this.props.fetchEmailRateLimiter()
  }

  render () {
    if (this.props.loading && !this.props.emailRateLimiter) {
      return <Spinner />
    }

    return <ConfigureRateLimiter
      loading={this.props.loading}
      emailRateLimiter={this.props.emailRateLimiter}
      setEmailRateLimiter={this.props.setEmailRateLimiter}
      updateRateLimiter={this.props.updateRateLimiter}
      administratorId={this.props.administratorId}
      submittedStatus={this.props.submittedStatus}
      />
  }
}

const mapStateToProps = (state) => {
  const { emailRateLimiter, loading, submittedStatus } = state.configureRateLimiterContainer
  const { administratorId } = state.administrationLoginContainer

  return {
    emailRateLimiter: emailRateLimiter,
    administratorId: administratorId,
    loading: loading,
    submittedStatus
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    setEmailRateLimiter,
    fetchEmailRateLimiter,
    updateRateLimiter
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfigureRateLimiterContainer)
